import { render, staticRenderFns } from "./ChangeVector.vue?vue&type=template&id=0cd482ce&scoped=true"
import script from "./ChangeVector.vue?vue&type=script&lang=js"
export * from "./ChangeVector.vue?vue&type=script&lang=js"
import style0 from "./ChangeVector.vue?vue&type=style&index=0&id=0cd482ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd482ce",
  null
  
)

export default component.exports